import * as React from "react";
import arrow_gray from "../../images/arrow_gray.gif";

interface Props {
  setSelectedPage: React.Dispatch<React.SetStateAction<string>>;
  setSelectedCountry: React.Dispatch<React.SetStateAction<string>>;
}

const MarketSelection: React.FC<Props> = (props) => {
  const { setSelectedPage, setSelectedCountry } = props;  

  const countrySelection = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (event.target.value === "Germany") {            
      setSelectedCountry(event.target.value);      
      setSelectedPage("GermanOptions");
    } else {            
      setSelectedCountry(event.target.value);      
      setSelectedPage("Acknowledgement");
    }
  };

  return (
    <div>
      <div style={{ marginTop: "10px" }}>
        Upload Beneficial Owner List - Step 1
      </div>
      <div
        style={{ marginTop: "10px", marginRight: "40px" }}
        className="inline"
      >
        <div style={{ fontWeight: "bold" }}>B.O. List Templates</div>

        <div className="inline" style={{ marginTop: 20 }}>
          <img src={arrow_gray} alt="" width="15" height="9"></img>
        </div>
        <div className="inline" style={{ width: 150, marginTop: 20 }}>
          Templates will appear after you select a market.
        </div>
        <br className="clearBoth" />
        <div className="inline" style={{ marginTop: 20 }}>
          <img src={arrow_gray} alt="" width="15" height="9"></img>
        </div>
        <div className="inline" style={{ width: 150, marginTop: 20 }}>
          Any new BO list will cancel and replace the previous one
        </div>
        <br className="clearBoth" />
      </div>

      <div className="inline" style={{ width: "63%" }}>
        <p className="subTitle" style={{ marginTop: "10px" }}>
          Market selection
        </p>
        <div style={{ marginTop: "10px" }}>
          Please select from the market list below.{" "}
        </div>
        <div
          style={{
            marginTop: "10px",
            padding: "40px",
            backgroundColor: "#f1f0f0",
          }}
        >
          <select
            style={{
              width: "200px",
              marginLeft: "35px",
              backgroundColor: "white",
            }}
            onChange={countrySelection}
          >
            <option value="">--Please select a market--</option>            
            <option value="Germany">Germany</option>
            <option value="Italy">Italy</option>
            <option value="Japan">Japan</option>            
            <option value="South Korea">South Korea</option>
            <option value="Spain">Spain</option>
            <option value="Singapore">Singapore</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default MarketSelection;
